<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { settingService } from '../../../services';
import config from "../../../config";
import { success_message, error_message } from '../../../Helper/helper';

/**
 * Starter component
 */
export default {
  data() {
    return {
      config:config,
      setting: [],
      setting: {
        vendor_listing_layout: ''
      }
    };
  },
   validations: {
    setting: {
      vendor_listing_layout: {
        required : requiredIf(function(form){
        	return !this.setting.vendor_listing_layout;
        })
      }
    },
  },
  mounted() {
    this.getAppSetting();
  },
  methods: {
    getAppSetting(){
      settingService.getAppSettingApi().then((response) => {
            this.setting = response.data.result.settings;
      })
    },
    generalIt(){
      this.$v.setting.$touch();
      if (this.$v.setting.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("vendor_listing_layout", this.setting.vendor_listing_layout);
        fd.append('type',4);
        settingService.updateAppSetting(fd).then((response) => {
          if (response.data.code === 200) {
              success_message(response.data.message);
            } else {
              error_message(response.data.message);
            }
        });
      }
    }
  }
};
</script>
<template>
  <b-form @submit.prevent="generalIt">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Vendor Listing Page Layout',{ vendor: $auth.setting.restaurant_name }) }}</label>
                  <select class="custom-select" id="vendor_listing_layout" name="vendor_listing_layout" v-model="setting.vendor_listing_layout">
                    <option v-bind:value="1" selected>{{ trans.get('__JSON__.Square') }}</option>
                    <option v-bind:value="2">{{ trans.get('__JSON__.Full') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 offset-sm-3">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Preview') }}</label>
                  <div v-if="setting.vendor_listing_layout == '1'" class="home-layout">
                    <img :src="config.vendorlistingimage+'1.png'">
                  </div>
                   <div v-else-if="setting.vendor_listing_layout == '2'" class="home-layout">
                    <img :src="config.vendorlistingimage+'2.png'">
                  </div>
                </div>
              </div>
            </div>

            <div class="btn-update">
              <div class="col-sm-6">
                <button
                  type="submit"
                  v-if="$auth.hasPermission(config.permissions.layout_write)"
                  class="btn btn-primary mr-1 mt-3"
                >{{ trans.get('__JSON__.Update') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>